export default "__VITE_ASSET__BObO9RJp__"